import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    buttonRegister:{
        '& .MuiButton-label':{
            justifyContent: 'space-between'
        }
    }
}));
